var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonHeader"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"discount-title",on:{"click":_vm.onBack}},[_vm._v(_vm._s(_vm.$t('自助优惠')))]),_c('img',{staticClass:"icon",attrs:{"src":require("../../../assets/image/discount/title-arrow.png"),"alt":""}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }